import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl } from "react-intl";
import { createSelector } from 'reselect';
import { set, setMulti,setOpenAdvanceFiltersDialog } from '../../../store/actions/pages';

import ChargeAnalysisTopFiltersComponent from './ChargeAnalysisTopFilters';
import { setRelativeFilter } from '../../../store/actions/chargeAnalysis';

export const ChargeAnalysisTopFilters = connect(
    () => {

        const selectSignificance = createSelector(
            (state) => state.pages['charge-analysis-landing'],
            (table: any) => {
                return table.significance;
            }
        );

        const selectCustomFilter = createSelector(
            (state) => state.pages['charge-analysis-landing'],
            (table: any) => {
                return table.customFilter;
            }
        );

        const selectPending = createSelector(
            (state) => state.pages,
            (state) => state.search.getByName.pending,
            (pages, searchPending) => {
                return pages['charge-analysis-landing'].pending || searchPending
            }
        );

        return (state:any, props) => ({
            significanceFlag: selectSignificance(state),
            customFilter: selectCustomFilter(state),
            relativeFilterValue: state.chargeAnalysis.relativeFilterValue,
            tableFilters:state.pages['charge-analysis-landing']?.filter,
            pageState:state.pages['charge-analysis-landing'],
            ignoreDueToQuickSearch:false,
            pending: selectPending(state),
            open: state.pages.open

        });
    },
    (dispatch) => ({
        actions: bindActionCreators({
            set: (value) => set('charge-analysis-landing', 'significance', value),
            setMulti: obj => setMulti('charge-analysis-landing', obj),
            setCustomFilter: (value) => set('charge-analysis-landing', 'customFilter', value),
            setRelativeFilter: setRelativeFilter,
            setOpenAdvanceFiltersDialog
        }, dispatch)
    })
)(injectIntl(ChargeAnalysisTopFiltersComponent));